import React from 'react';
import { useInfoCollectionFormCtx } from 'pages/Main/QRScreens/hooks/useInfoCollectionFormCtx';
import { FormTextField } from 'components/__v5__/FormTextField';

export const Email: React.FC = () => {
  const { control } = useInfoCollectionFormCtx();
  return (
    <FormTextField
      name="email"
      control={control}
      label="Email*"
      placeholder="Email"
      showError
    />
  );
};
